import { FC, useMemo } from "react";

import { Grid, useResponsive } from "capitalrx-components-2.0/lib/layout";
import { Shelf } from "capitalrx-components-2.0/lib/layout";

import { LanguageSwitcher } from "@/common/components";
import styled, { useTheme } from "styled-components";


const CONTAINER_HEIGHT = "80px";

const LogoContainer = styled.div<{ $isMobile?: boolean; }>`
  display: flex;
  align-items: center;
  height: 66px;
`;

const Logo = styled.img`
  max-height: 100%;
  max-width: 100%;
`;

const HeaderContainer = styled.div<{ $isMobile?: boolean; }>`
  padding: ${(props) => props.$isMobile ? "10px" : "10px 0"};
  background-color: white;
`;

export const ThemedHeader: FC = () => {
  const theme = useTheme();
  const { setLogoFlush } = useResponsive(
    useMemo(
      () => ({
        setLogoFlush: { desktop: false, tablet: false, mobile: true },
      }),
      [],
    ),
  );

  return (
    <HeaderContainer $isMobile={setLogoFlush}>
      <Grid>
        {!setLogoFlush && <Grid.Span columns={1} />}
        <Grid.Span columns={setLogoFlush ? 12 : 10}>
          <Shelf alignment="center">
            <LogoContainer $isMobile={setLogoFlush}>
              <Logo src={theme.logo_desktop} alt="client logo" />
            </LogoContainer>
            <Shelf.Spacer />
            <LanguageSwitcher />
          </Shelf>
        </Grid.Span>
        {!setLogoFlush && <Grid.Span columns={1} />}
      </Grid>
    </HeaderContainer>
  );
};

export const ThemedGradient = styled.div`
  background-image: linear-gradient(to left, #989898, #4a4a4a);
  padding: 56px;
  border-bottom: solid 6px ${(props) => props.theme.primary_color};
  height: 246px;
  position: absolute;
  z-index: -1;
  width: 100%;
  top: ${CONTAINER_HEIGHT};
`;
